import { render } from "./TrainingModal.vue?vue&type=template&id=2dcb8974"
import script from "./TrainingModal.vue?vue&type=script&lang=js"
export * from "./TrainingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__